import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { CustomerTypes } from "@faire/help-center-utils/enums/CustomerType";
import { getCustomerType } from "@faire/help-center-utils/lib/customer";
import { localeString } from "@faire/help-center-utils/lib/localeString";
import { isLoggedInBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getSettingHelpCenterSearchAndNavImprovementsWithoutAssignment } from "@faire/help-center-utils/settings/getSettingHelpCenterSearchAndNavImprovements";
import { useQuery as useZendeskArticles } from "@faire/web-api/api/zendesk/locale/articles/articleId/get-hooks";
import { useQuery as useZendeskSections } from "@faire/web-api/api/zendesk/locale/sections/get-hooks";
import { route as homeRoute } from "@faire/web-api/routes/support";
import { route as brandsRoute } from "@faire/web-api/routes/support/brands";
import { route as retailersRoute } from "@faire/web-api/routes/support/retailers";
import { QueryParameters as SearchQueryParams, route as searchRoute } from "@faire/web-api/routes/support/search";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useArticleContextStore } from "../views/articles/hooks/ArticleContext";
import { useArticleId } from "../views/articles/hooks/useArticleId";
export var useCustomerType = function useCustomerType() {
  var _zendeskArticleRespon, _sectionsResponse$sec, _ref, _ref2, _currentSection$;
  var _useParams = useParams(),
    categoryIdParam = _useParams.categoryId;
  var _useQueryParams = useQueryParams(SearchQueryParams.parse),
    categoryIdQueryParam = _useQueryParams.categoryId;
  var articleId = useArticleId();
  var _useArticleContextSto = useArticleContextStore(["articleData"]),
    _useArticleContextSto2 = _slicedToArray(_useArticleContextSto, 1),
    articleData = _useArticleContextSto2[0].articleData;
  var _useZendeskArticles = useZendeskArticles(localeString, articleId !== null && articleId !== void 0 ? articleId : "", {
      include: undefined
    }, {
      enabled: !!articleId && articleData && articleData.article && articleId !== String(articleData.article.id)
    }),
    zendeskArticleResponse = _useZendeskArticles.data;
  var location = useLocation();
  var shouldFetchSections = location.pathname !== homeRoute && location.pathname !== brandsRoute && location.pathname !== retailersRoute && location.pathname !== searchRoute;
  var _useZendeskSections = useZendeskSections(localeString, {
      enabled: shouldFetchSections
    }),
    sectionsResponse = _useZendeskSections.data;
  var articleSections = zendeskArticleResponse === null || zendeskArticleResponse === void 0 ? void 0 : zendeskArticleResponse.sections;
  var articleSection = articleSections === null || articleSections === void 0 ? void 0 : articleSections[0];
  var _useParams2 = useParams(),
    topicId = _useParams2.topicId;
  var sectionId = topicId !== null && topicId !== void 0 ? topicId : zendeskArticleResponse === null || zendeskArticleResponse === void 0 ? void 0 : (_zendeskArticleRespon = zendeskArticleResponse.article) === null || _zendeskArticleRespon === void 0 ? void 0 : _zendeskArticleRespon.section_id;
  var sections = articleSections !== null && articleSections !== void 0 && articleSections.length ? articleSections : (_sectionsResponse$sec = sectionsResponse === null || sectionsResponse === void 0 ? void 0 : sectionsResponse.sections) !== null && _sectionsResponse$sec !== void 0 ? _sectionsResponse$sec : [];
  var currentSection = sections.filter(function (section) {
    return section.id === Number(sectionId);
  });
  var categoryId = (_ref = (_ref2 = categoryIdParam !== null && categoryIdParam !== void 0 ? categoryIdParam : categoryIdQueryParam) !== null && _ref2 !== void 0 ? _ref2 : currentSection === null || currentSection === void 0 ? void 0 : (_currentSection$ = currentSection[0]) === null || _currentSection$ === void 0 ? void 0 : _currentSection$.category_id) !== null && _ref !== void 0 ? _ref : articleSection === null || articleSection === void 0 ? void 0 : articleSection.category_id;
  var customerType = useMemo(function () {
    if (location.pathname === brandsRoute) {
      return CustomerTypes.BRAND;
    } else if (location.pathname === retailersRoute) {
      return CustomerTypes.RETAILER;
    } else if (location.pathname === homeRoute && getSettingHelpCenterSearchAndNavImprovementsWithoutAssignment()) {
      if (isLoggedInBrand()) {
        return CustomerTypes.BRAND;
      }
      return CustomerTypes.RETAILER;
    } else {
      return getCustomerType(Number(categoryId));
    }
  }, [location.pathname, categoryId]);
  return {
    customerType: customerType
  };
};